import type { SearchParams } from "@/modules/jobAds/client/api/types"

import { LOCALE_NONE } from "@/modules/jobAds/client/constants"

export const areSearchParamsEmpty = (searchParams: SearchParams): boolean =>
  Object.values(searchParams).every(value => {
    if (typeof value === "number") {
      return !value
    }

    return value.length === 0
  })

// TODO - https://jobteaser.atlassian.net/jira/software/projects/DUX/boards/115?selectedIssue=DUX-4250 - remove this helper in favour of a more generic one shared across all module
// The right time will be when we migrate to the new saved search api version
export const computeSearchParamsFromURLSearchParams = (searchParams: URLSearchParams): SearchParams => {
  const abroadOnly = searchParams.get("abroad_only") || ""
  const candidacyTypes = Array.from(searchParams.getAll("candidacy_type"))
  const companyBusinessTypes = Array.from(searchParams.getAll("company_business_type"))
  const companySectors = Array.from(searchParams.getAll("company_sectors"))
  const contractDurations = Array.from(searchParams.getAll("contract_duration"))
  const contracts = Array.from(searchParams.getAll("contract"))
  const exclusive = Array.from(searchParams.getAll("exclusive"))
  const jobWithImpact = searchParams.get("job_with_impact") || ""
  const keywords = searchParams.get("q") || ""
  const lat = searchParams.get("lat") || ""
  const lng = searchParams.get("lng") || ""
  const locales = Array.from(searchParams.getAll("locale").filter(locale => locale !== LOCALE_NONE))
  const localizedLocation = searchParams.get("localized_location") || ""
  const locations = Array.from(searchParams.getAll("location"))
  const positionCategories = Array.from(searchParams.getAll("position_category_uuid"))
  let publicationDate = searchParams.get("publication_date") || ""
  publicationDate = publicationDate === "no-time-limit" ? "" : publicationDate
  const radius = searchParams.get("radius") || ""
  const remoteTypes = Array.from(searchParams.getAll("remote_types"))
  const startDates = Array.from(searchParams.getAll("start_date"))
  const studyLevels = Array.from(searchParams.getAll("study_levels"))
  const tags = Array.from(searchParams.getAll("tags"))
  const workExperienceCodes = Array.from(searchParams.getAll("work_experience_code"))

  return {
    abroadOnly,
    candidacyTypes,
    companyBusinessTypes,
    companySectors,
    contractDurations,
    contracts,
    exclusive,
    jobWithImpact,
    keywords,
    lat,
    lng,
    locales,
    localizedLocation,
    locations,
    positionCategories,
    publicationDate,
    radius,
    remoteTypes,
    startDates,
    studyLevels,
    tags,
    workExperienceCodes,
  }
}
